import React, { useEffect, useState, useRef } from "react";
import "../assets/styles/Header.css";
import logo from "../assets/logo.png"; // ← update path if needed

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Features", href: "#features" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener("mousedown", onOutside);
    return () => document.removeEventListener("mousedown", onOutside);
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`header-wrapper ${scrolled ? "scrolled" : ""}`}>
      <div className="container-fluid px-4 px-lg-5">
        <div className="header-pill" ref={navRef}>
          <nav className="header-nav">
            {/* ── Logo ── */}
            <a href="#home" className="logo-link">
              <img src={logo} alt="Sunleaf Villa" className="logo-img" />
            </a>

            {/* ── Desktop + Mobile Nav ── */}
            <div className={`nav-links-wrapper ${menuOpen ? "open" : ""}`}>
              <ul className="nav-links">
                {NAV_LINKS.map(({ label, href }) => (
                  <li key={label}>
                    <a href={href} onClick={closeMenu}>
                      {label}
                    </a>
                  </li>
                ))}
                <li>
                  <a href="#contact" className="btn-book" onClick={closeMenu}>
                    Book Now
                  </a>
                </li>
              </ul>
            </div>

            {/* ── Mobile Toggle ── */}
            <button
              className="nav-toggle"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="Toggle menu"
              aria-expanded={menuOpen}
            >
              {menuOpen ? "✕" : "☰"}
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
